import Phaser from "phaser";
import Bao, { BaoAction } from "../components/graphic/Bao";
import Settings from "../components/settings";
import Graphic from "../components/system/Graphic";
import styled from "styled-components";

import { UIContainer, UIScene } from "../components/ui/UITypes";


const Vector2 = Phaser.Math.Vector2;
export default class Game extends UIScene {
  bao: Bao;
  headButton: Phaser.GameObjects.Image;
  tailButton: Phaser.GameObjects.Image;
  stopButton: Phaser.GameObjects.Image;
  progressbarFill: Phaser.GameObjects.Image;
  progressbarBorder: Phaser.GameObjects.Image;

  popup: Phaser.GameObjects.Container;

  isWon: boolean;
  isTossing: boolean;

  prizeList: {
    id: number;
    order: number;
    drop_rate: number;
    img_url: string;
  }[];
  curPrize: number;
  lastPrize: number = 0;
  isEnd: boolean;
  constructor() {
    super({ key: "Game" });

    this.bao = new Bao(this, { x: -80, y: 75 }, this.updateProgress);
    this.curPrize = 0;
    this.isEnd = false;

    //set prize list
    this.prizeList = [
      { id: 1, order: 1, drop_rate: 0.05, img_url: "" },
      { id: 2, order: 2, drop_rate: 0.05, img_url: "" },
      { id: 3, order: 3, drop_rate: 0.05, img_url: "" },
      { id: 4, order: 4, drop_rate: 0.05, img_url: "" },
      { id: 5, order: 5, drop_rate: 0.05, img_url: "" },
      { id: 6, order: 6, drop_rate: 0.05, img_url: "" },
      { id: 7, order: 7, drop_rate: 0.05, img_url: "" },
      { id: 8, order: 8, drop_rate: 0.05, img_url: "" },
      { id: 9, order: 9, drop_rate: 0.05, img_url: "" },
      { id: 10, order: 10, drop_rate: 0.05, img_url: "" },
    ];
  }

  //Global Variables

  //For Responsiveness
  lastWidth: number = 0;
  lastHeight: number = 0;
  //Hero Selection
  currentSelection: number = -1;
  //Images Caches
  imagesCache = [];

  //GameObject Tags
  tags = [];

  //Backgrounds
  Sprites: Phaser.GameObjects.Image[] = [];
  maskShape: Phaser.GameObjects.Graphics;

  preload() {
    //Load SFX
    loadSFX(this);

    this.bao.load();

    this.load.image("background", "assets/bg/FullHD16_9.png");
    this.load.image("gameBG", "assets/bg/BG.png");

    this.load.image("headButton", "assets/button/HeadButton.png");
    this.load.image("stopButton", "assets/button/StopButton.png");
    this.load.image("tailButton", "assets/button/TailButton.png");

    this.load.image("fill", "assets/progressbar/insidebar.png");
    this.load.image("border", "assets/progressbar/outsidebar.png");
    //Caching the Images
    this.load.on("load", (file: any) => {
      if (file.type === "image")
        this.imagesCache.push({
          key: file.key,
          blobURL: URL.createObjectURL(file.xhrLoader.response),
        });
    });

    this.load.on("filecomplete", (key: any, type: any, data: any) => {
      if (type === "image") {
        data.blobURL = this.imagesCache.find(
          (target: any) => target.key === key
        ).blobURL;
      }
    });

    this.load.on("progress", (progress: any) =>
      console.log(`Loading... ${progress.toFixed(2) * 100}%`)
    );

    //Complete
    this.load.once("complete", () => {
      //Play Music
      this.sfx_bgm.play({ volume: 0.2 });
    });
  }

  create() {
    //Delete imagesCache
    this.imagesCache = null;

    // this.sfx_select = this.sound.add("select");

    this.addToSprites(this.addImage("background"));
    this.addToSprites(this.addImage("gameBG"));
    //head
    this.headButton = this.addImage("headButton");
    this.addToSprites(this.headButton);
    //tail
    this.tailButton = this.addImage("tailButton");
    this.addToSprites(this.tailButton);
    //stop
    this.stopButton = this.addImage("stopButton");
    this.addToSprites(this.stopButton);
    //progress Fill
    this.progressbarFill = this.addImage("fill");
    this.addToSprites(this.progressbarFill);
    //progress Border
    this.progressbarBorder = this.addImage("border");
    this.addToSprites(this.progressbarBorder);
    // this.addToSprites(this.addImage("buttonPush"));
    // this.get("buttonPush").visible = false;

    this.scaleResponsively(this.headButton, 0.08);
    this.scaleResponsively(this.tailButton, 0.08);
    this.scaleResponsively(this.stopButton, 0.08);

    this.scaleResponsively(this.progressbarFill);
    this.scaleResponsively(this.progressbarBorder);
    // this.scaleResponsively(this.get("buttonPush"), 0.17);

    //Settings Responsive BG
    this.scaleResponsively(this.get("gameBG"));

    this.bao.create();

    //Bring foreground to front
    this.children.bringToTop(this.headButton);
    this.children.bringToTop(this.tailButton);
    this.children.bringToTop(this.stopButton);
    this.children.bringToTop(this.progressbarFill);

    //Mask
    this.maskShape = this.make.graphics({});
    //  Create a hash shape Graphics object
    this.maskShape.fillStyle(0xffffff);
    //  You have to begin a path for a Geometry mask to work
    this.maskShape.beginPath();
    this.maskShape.fillRect(-100, 0, 200, this.progressbarBorder.displayHeight);
    const mask = this.maskShape.createGeometryMask();
    this.progressbarFill.setMask(mask);

    this.handleResize();
    console.log("Game.tsx initiated!");

    // this.onReady();

    //Set Interactivity
    this.headButton.setInteractive();
    this.tailButton.setInteractive();
    this.stopButton.setInteractive();
    // this.get("buttonPush").setInteractive();

    this.headButton.on("pointerdown", () => {
      if (this.isTossing || this.isEnd) return;
      this.headButton.setPosition(this.headButton.x, (this.headButton.y += 2));
    });

    this.headButton.on("pointerup", () => {
      if (this.isTossing || this.isEnd) return;
      this.userGuess(true);
      this.headButton.setPosition(this.headButton.x, (this.headButton.y -= 2));
      this.sfx_cointoss.play();
      setTimeout(() => {
        this.sfx_jump.play();
      }, 500);
    });

    this.tailButton.on("pointerdown", () => {
      if (this.isTossing || this.isEnd) return;
      this.tailButton.setPosition(this.tailButton.x, (this.tailButton.y += 2));
    });

    this.tailButton.on("pointerup", () => {
      if (this.isTossing || this.isEnd) return;
      this.userGuess(false);
      this.tailButton.setPosition(this.tailButton.x, (this.tailButton.y -= 2));
      this.sfx_cointoss.play();
      setTimeout(() => {
        this.sfx_jump.play();
      }, 500);
    });

    this.stopButton.on("pointerdown", () => {
      if (this.isTossing || this.isEnd) return;
      this.stopButton.setPosition(this.stopButton.x, (this.stopButton.y += 2));
    });

    this.stopButton.on("pointerup", () => {
      if (this.isTossing || this.isEnd) return;
      this.userStopPlay();
      this.stopButton.setPosition(this.stopButton.x, (this.stopButton.y -= 2));
    });

    //Start Game
    this.GameStartPhase();
  }

  get(key) {
    return this.Sprites.find((t) => t.name === key);
  }

  addImage(key) {
    return this.add.image(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
      key
    );
  }

  showPopup() {
    const popupSize = { width: 300, height: 300 };
    const Container = styled.div`
      width: ${popupSize.width}px;
      height: ${popupSize.height}px;
      background-color: white;
      border-radius: 20px;

      display: flex;
      justify-content: space-evenly;
      align-items: center;

      flex-direction: column;
    `;

    const Button = styled.div`
      cursor: pointer;
      color: white;
      padding: 10px;
      height: 20px;
      background-color: green;
      border-radius: 4px;
    `;

    const Text = styled.div`
      font-weight: 900;
    `;

    Graphic.Draw(
      this,
      new Vector2(window.innerWidth / 2, window.innerHeight / 2),
      new Vector2(popupSize.width, popupSize.height),
      () => (
        <Container>
          <Text>{`PRIZE TIER ${this.lastPrize}`}</Text>
          <img src="https://picsum.photos/100/100" />
          <Button
            onClick={() => {
              Graphic.Destroy(this, this.popup);
              this.isEnd = false;
            }}
          >
            Confirm
          </Button>
        </Container>
      ),
      "",
      "",
      true,
      0.5,
      (myGraphic) => (this.popup = myGraphic.container)
    );
  }

  addToSprites(sprite: Phaser.GameObjects.Image) {
    sprite.name = sprite.texture.key;
    this.Sprites.push(sprite);
  }

  scaleResponsively(target, scale = 1) {
    let width =
      window.innerWidth > Settings.MAX_MOBILE_WIDTH
        ? Settings.MAX_MOBILE_WIDTH
        : window.innerWidth;
    let height = window.innerHeight;

    target.x = width / 2;
    target.y = height / 2;
    let rescaleX = width / target.width;
    let rescaleY = height / target.height;
    let rescale = Math.max(rescaleX, rescaleY);
    target.setScale(rescale * scale).setScrollFactor(0);
  }

  update() {
    //Resize
    if (
      window.innerWidth !== this.lastWidth ||
      window.innerHeight !== this.lastHeight
    ) {
      this.lastWidth = window.innerWidth;
      this.lastHeight = window.innerHeight;
      this.handleResize();
    }

    this.bao.update();

    //restart, for debuging
    let spacebar = this.input.keyboard.addKey(
      Phaser.Input.Keyboard.KeyCodes.SPACE
    );
    if (Phaser.Input.Keyboard.JustDown(spacebar)) {
      this.isEnd = false;
      console.log("RESTART!");
    }
  }

  //#region |> METHODS

  //Check Device aspect ratio
  handleResize() {
    // console.log("resized");
    this.calculateSize();
  }

  calculateSize() {
    if (this.popup)
      this.popup.setPosition(window.innerWidth / 2, window.innerHeight / 2);

    this.game.scale.resize(window.innerWidth - 4, window.innerHeight - 4);

    if (this.get("background")) {
      this.get("background").x = this.cameras.main.width / 2;
      this.get("background").y = this.cameras.main.height / 2;
      let scaleX = this.cameras.main.width / this.get("background").width;
      let scaleY = this.cameras.main.height / this.get("background").height;
      let scale = Math.max(scaleX, scaleY);
      this.get("background").setScale(scale).setScrollFactor(0);
    }

    const TargetBackgrounds = ["gameBG", "gameFG", "gameFG2", "gameFG3"];
    const AllBackground = this.Sprites.filter((t) =>
      TargetBackgrounds.includes(t.name)
    );

    AllBackground.forEach((bg) => {
      bg.setPosition(window.innerWidth / 2, window.innerHeight / 2);
    });

    //Responsive Sprite |> IMPORTANT

    if (this.bao) {
      this.bao.setPosition(window.innerWidth / 2, window.innerHeight / 2);
    }

    // if (this.spinner) {
    // this.spinner.setPosition(window.innerWidth / 2, window.innerHeight / 2);
    // }

    //***On Object Itself
    // setPosition(x: number, y: number) {
    //   const offsetX = this.offsetPosition.x * this.bao.scaleX;
    //   const offsetY = this.offsetPosition.y * this.bao.scaleY;

    //   this.bao.setPosition(x + offsetX, y + offsetY);
    // }

    const buttonGap = 325 * this.headButton.scale;

    if (this.headButton) {
      const offsetY = 800 * this.headButton.scaleY;
      this.headButton.setPosition(
        window.innerWidth / 2 - buttonGap,
        window.innerHeight / 2 + offsetY
      );
    }
    if (this.tailButton) {
      const offsetY = 800 * this.tailButton.scaleY;
      this.tailButton.setPosition(
        window.innerWidth / 2,
        window.innerHeight / 2 + offsetY
      );
    }
    if (this.stopButton) {
      const offsetY = 800 * this.stopButton.scaleY;
      this.stopButton.setPosition(
        window.innerWidth / 2 + buttonGap,
        window.innerHeight / 2 + offsetY
      );
    }
    if (this.progressbarBorder) {
      const offsetX = 840 * this.progressbarBorder.scaleX;
      const offsetY = -300 * this.progressbarBorder.scaleY;

      this.progressbarBorder.scale =
        (this.get("gameBG").displayHeight / this.progressbarBorder.height) *
        0.7;

      this.progressbarBorder.setPosition(
        window.innerWidth / 2 + offsetX,
        window.innerHeight / 2 + offsetY
      );
    }

    if (this.progressbarFill) {
      const offsetX = 840 * this.progressbarFill.scaleX;
      const offsetY = -300 * this.progressbarFill.scaleY;

      this.progressbarFill.scale =
        (this.get("gameBG").displayHeight / this.progressbarFill.height) * 0.7;

      this.progressbarFill.setPosition(
        window.innerWidth / 2 + offsetX,
        window.innerHeight / 2 + offsetY
      );
    }

    let percent = 0;
    //0.2 0.25 0.305 0.37 0.435 0.5 0.57 0.64 0.71 1.0
    switch (this.curPrize) {
      case 0:
        percent = 0;
        break;
      case 1:
        percent = 0.2;
        break;
      case 2:
        percent = 0.25;
        break;
      case 3:
        percent = 0.305;
        break;
      case 4:
        percent = 0.37;
        break;
      case 5:
        percent = 0.435;
        break;
      case 6:
        percent = 0.5;
        break;
      case 7:
        percent = 0.57;
        break;
      case 8:
        percent = 0.64;
        break;
      case 9:
        percent = 0.71;
        break;
      case 10:
        percent = 1.0;
        break;
    }
    // this.maskShape.x = this.progressbarBorder.x;
    // this.maskShape.y =
    //   this.progressbarBorder.y +
    //   this.progressbarBorder.displayHeight / 2 -
    //   this.progressbarBorder.displayHeight * percent;

    this.tweens.add({
      targets: this.maskShape,
      x: this.progressbarBorder.x,
      y:
        this.progressbarBorder.y +
        this.progressbarBorder.displayHeight / 2 -
        this.progressbarBorder.displayHeight * percent,
      duration: 1000,
      ease: "Expo.easeOut",
    });
  }

  updateProgress = () => {
    console.log("UPDATE");
    if (this.isWon) {
      this.isWon = false;
      this.sfx_levelup.play();
      if(this.curPrize > 1 && this.curPrize % 2 !== 0) {
        setTimeout(() => {
          this.sfx_nice.play();
        }, 1000);
      }
        
    } else {
      this.showPopup();
      this.sfx_leveldown.play();
    }

    this.isTossing = false;

    let percent = 0;
    //0.2 0.25 0.305 0.37 0.435 0.5 0.57 0.64 0.71 1.0
    switch (this.curPrize) {
      case 0:
        percent = 0;
        break;
      case 1:
        percent = 0.2;
        break;
      case 2:
        percent = 0.25;
        break;
      case 3:
        percent = 0.305;
        break;
      case 4:
        percent = 0.37;
        break;
      case 5:
        percent = 0.435;
        break;
      case 6:
        percent = 0.5;
        break;
      case 7:
        percent = 0.57;
        break;
      case 8:
        percent = 0.64;
        break;
      case 9:
        percent = 0.71;
        break;
      case 10:
        percent = 1.0;
        break;
    }
    // this.maskShape.x = this.progressbarBorder.x;
    // this.maskShape.y =
    //   this.progressbarBorder.y +
    //   this.progressbarBorder.displayHeight / 2 -
    //   this.progressbarBorder.displayHeight * percent;
    this.tweens.add({
      targets: this.maskShape,
      x: this.progressbarBorder.x,
      y:
        this.progressbarBorder.y +
        this.progressbarBorder.displayHeight / 2 -
        this.progressbarBorder.displayHeight * percent,
      duration: 1000,
      ease: "Expo.easeOut",
    });
  };

  //#region |> Game Phase

  //Game Phase
  GameStartPhase() {
    console.log("----Game Start Phase----");
    this.bao.play(BaoAction.idle);
  }

  //Required function
  //call when user press stop button, create a pop-up to display a result
  userStopPlay() {
    this.isEnd = true;
    //show popp-up result
    this.showPopup();
  }

  //call when user press head or tail button, calculate a probabilities
  userGuess(isHead: boolean) {
    //random result
    let random = Math.random() < 0.5;
    console.log("is head, user guess: ", random, isHead);
    if (random) this.bao.play(BaoAction.head);
    else this.bao.play(BaoAction.tail);

    this.isTossing = true;
    //Adjust Position
    if (
      (this.bao.bao.anims.currentAnim.key === BaoAction.tail ||
        this.bao.bao.anims.currentAnim.key === BaoAction.head) &&
      !this.bao.isAdjusted
    ) {
      this.bao.isAdjusted = true;
      this.bao.bao.x += 30;
      this.bao.bao.y += 10;
    }
    this.userAfterGuess(random === isHead);
  }

  //call after userGuess(), compare result with user guess
  userAfterGuess(result: boolean) {
    if (result) {
      this.curPrize++;
      this.isWon = true;

      if (this.curPrize === 10) {
        this.isEnd = true;
      }

      this.lastPrize = this.curPrize;
    } else {
      this.isEnd = true;
      this.curPrize = 0;
    }

    console.log("RESULT: ", result, this.curPrize);
  }

  //#endregion

  //#endregion
}

const loadSFX = (scene: UIScene) => {
  scene.load.audio("bg", ["assets/sfx/bg.mp3"]);
  scene.load.audio("cointoss", ["assets/sfx/cointoss.mp3"]);
  scene.load.audio("jump", ["assets/sfx/jump.m4a"]);
  scene.load.audio("leveldown", ["assets/sfx/leveldown.m4a"]);
  scene.load.audio("levelup", ["assets/sfx/levelup.m4a"]);
  scene.load.audio("nice", ["assets/sfx/nice.m4a"]);
  scene.load.on("complete", () => {
    scene.sfx_bgm = scene.sound.add("bg", { loop: true });
    scene.sfx_cointoss = scene.sound.add("cointoss");
    scene.sfx_jump = scene.sound.add("jump");
    scene.sfx_levelup = scene.sound.add("levelup");
    scene.sfx_leveldown = scene.sound.add("leveldown");
    scene.sfx_nice = scene.sound.add("nice");
  });
};
